/**
 * ko-admin#313 / ko-backend#1059 — step-up MFA.
 *
 * Some account actions (staff changes, exports, banning or suspending an
 * ADMIN/STAFF account…) need a TOTP code from the last five minutes, not just
 * a session that passed MFA at login. The backend answers 403 with
 * `MFA_STEP_UP_REQUIRED`, and the request is sent again — same method, body and
 * Idempotency-Key — with the code in `X-MFA-Code`. A wrong or reused code
 * answers `MFA_STEP_UP_INVALID_CODE`, and the operator is asked again.
 *
 * The http layer cannot draw a dialog, so the UI registers how to ask, the
 * same way `registerAuthRuntime` hands it the tokens. With nobody registered
 * (tests, the login screen) the 403 is thrown as it came.
 */

export const STEP_UP_HEADER = 'X-MFA-Code';
export const STEP_UP_REQUIRED = 'MFA_STEP_UP_REQUIRED';
export const STEP_UP_INVALID = 'MFA_STEP_UP_INVALID_CODE';

/**
 * Asks the operator for a code. `invalid` is true when the previous one was
 * refused. Resolves to the code, or null when the operator cancels.
 */
export type StepUpPrompter = (ctx: { invalid: boolean }) => Promise<string | null>;

let prompter: StepUpPrompter | null = null;

/** Returns the function that unregisters it, for an effect's cleanup. */
export function registerStepUpPrompter(fn: StepUpPrompter): () => void {
  prompter = fn;
  return () => {
    if (prompter === fn) prompter = null;
  };
}

export function getStepUpPrompter(): StepUpPrompter | null {
  return prompter;
}
